import React, { useState } from 'react'
import { Form, Row, Col, Input, Button, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { toast } from 'react-toastify'
import apiRequest from '../../hooks/ApiRequest'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const CashPaymentForm = ({ form, policydetail, onSuccess, paymentType }) => {
  const { getFieldDecorator, validateFields, resetFields } = form
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const history = useHistory()

  const handleSubmit = e => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      const formData = new FormData()
      formData.append('PolicyNumber', policydetail?.policynumber)
      formData.append('ReceiptNumber', values.receiptNumber)
      formData.append('AmountPaid', values.amountPaid)
      formData.append('File', fileList[0]?.originFileObj)

      try {
        const res = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/Policy/UploadPaymentProof/upload-payment-proof`,
          'POST',
          formData
        )

        if (res.success) {
          toast.success(`${paymentType === 'Cash' ? 'Cash' : 'Bank'} payment submitted successfully`)
          resetFields()
          setFileList([])
          history.push('/policies')
          if (onSuccess) onSuccess()
        } else {
          toast.error(res.message || 'Failed to submit payment')
        }
      } catch (err) {
        toast.error('Submission error')
      } finally {
        setLoading(false)
      }
    })
  }

  // const handleUploadChange = ({ fileList }) => {
  //   setFileList(fileList.slice(-1)) // Limit to 1 file
  // }

  const handleUploadChange = ({ fileList }) => {
    const latestFile = fileList.slice(-1)
    setFileList(latestFile)
    form.setFieldsValue({ proofOfPayment: latestFile.length ? latestFile : null })
  }

  if (paymentType !== 'Cash' && paymentType !== 'BankTransfer') {
    return null
  }

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Row gutter={16}>
        <Col md={8}>
          <Form.Item label="Payment Amount(Per Term)">
            <Input placeholder="Enter receipt number" value={policydetail?.grandtotaltermpremium} disabled={true} />
          </Form.Item>
        </Col>

        <Col md={8}>
          <Form.Item label="Receipt Number">
            {getFieldDecorator('receiptNumber', {
              rules: [{ required: paymentType === "Cash" ? true : false, message: 'Please enter receipt number' }],
            })(<Input placeholder="Enter receipt number" />)}
          </Form.Item>
        </Col>

        <Col md={8}>
          <Form.Item label="Amount Paid">
            {getFieldDecorator('amountPaid', {
              rules: [{ required: true, message: 'Please enter amount paid' }],
            })(<Input placeholder="Enter amount paid" type="number" />)}
          </Form.Item>
        </Col>

        <Col md={8}>
          <Form.Item label="Proof of Payment">
            {paymentType === 'Cash' ? (
              <Upload
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleUploadChange}
              >
                <Button icon={<UploadOutlined />}>Upload File</Button>
              </Upload>
            ) : (
              getFieldDecorator('proofOfPayment', {
                rules: [{ required: true, message: 'Please upload proof of payment' }],
              })(
                <Upload
                  beforeUpload={() => false}
                  fileList={fileList}
                  onChange={handleUploadChange}
                >
                  <Button icon={<UploadOutlined />}>Upload File</Button>
                </Upload>
              )
            )}
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Submit Payment
        </Button>
      </Form.Item>
    </Form>
  )
}

export default Form.create({ name: 'cash_payment_form' })(CashPaymentForm)
